export default "__VITE_ASSET__b52d33f1__"